import React from 'react';
import styled from 'styled-components';
import { _ } from '_locales';

const WaitContainer = styled.div`
  background: rgba(255,255,255,0.8);
  height: 100%;
  position: absolute;
  text-align: center;
  top: 0px;
  left: 0;
  width: 100%;
  z-index: 999999;
`;

const WaitBox = styled.div`
  width: 250px;
  background: rgba(0, 0, 0, 0.75);
  color: rgb(255, 255, 255);
  margin: 92px auto;
  z-index: 2;
  padding: 18px 0;
   
  font-size: 15px !important;
  border-radius: 15px;
`;

/**
 * This component is for to showing the wait screen
 */
const WaitScreen = () => (
  <WaitContainer>
    <WaitBox>{_('general.please_wait')}</WaitBox>
  </WaitContainer>
);

export default WaitScreen;
